"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-MoveCollections',
    isLoading: 'c-MoveCollections--IsLoading',
    content: 'c-MoveCollections__Content',
    jobContent: 'c-MoveCollectionsJob__Content',
    menu: 'c-MoveCollections__Menu',
};
exports.Style = {
    [exports.CSS.container]: {
        width: '600px',
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center',
    },
    [exports.CSS.content]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around',
    },
    [exports.CSS.jobContent]: {
        display: 'flex',
        'align-items': 'start',
        'flex-direction': 'column',
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%',
        },
    },
};
//# sourceMappingURL=collection.move.modal.style.js.map